// assets
import { IconBrandFramer, IconTypography, IconPalette, IconShadow, IconWindmill, IconLayoutGridAdd, IconBuildingStore, IconBuildingFortress, IconCash, IconBrandCarbon, IconTrendingUp, IconGraph, IconUsers } from '@tabler/icons';

// constant
const icons = {
    IconTypography: IconTypography,
    IconPalette: IconPalette,
    IconShadow: IconShadow,
    IconWindmill: IconWindmill,
    IconBrandFramer: IconBrandFramer,
    IconCash: IconCash,
    IconBrandCarbon: IconBrandCarbon,
    IconUsers: IconUsers,
    IconTrendingUp: IconTrendingUp,
    IconGraph: IconGraph,
    IconLayoutGridAdd: IconLayoutGridAdd,
    IconBuildingStore: IconBuildingStore,
    IconBuildingFortress: IconBuildingFortress
};

//-----------------------|| UTILITIES MENU ITEMS ||-----------------------//

export const utilities = {
    id: 'utilities',
    title: 'Tools',
    type: 'group',
    children: [
        // {
        //     id: 'util-strategies',
        //     title: 'Marketplace',
        //     type: 'item',
        //     url: '/utils/strategies',
        //     icon: icons['IconBuildingStore'],
        //     breadcrumbs: false
        // },
        {
            id: 'util-prediction',
            title: 'AI Chat ✨',
            type: 'item',
            url: '/utils/chat',
            icon: icons['IconShadow'],
            breadcrumbs: false,
            accessRoles: [1, 2, 3]
            // chip: {
            //     label: "✨",
            //     color: "primary",
            //     // size: "small"
            // }
        },
        {
            id: 'util-apis',
            title: 'Custom Data',
            type: 'item',
            url: '/utils/apis',
            icon: icons['IconWindmill'],
            breadcrumbs: false,
            accessRoles: [1, 2, 3]
        },
        // {
        //     id: 'util-code',
        //     title: 'Strategy Builder',
        //     type: 'item',
        //     url: '/utils/code_old',
        //     icon: icons['IconBrandFramer'],
        //     breadcrumbs: false
        // },
        {
            id: 'util-news',
            title: 'Asset Search',
            type: 'item',
            url: '/utils/stock-search',
            icon: icons['IconLayoutGridAdd'],
            breadcrumbs: false,
            accessRoles: [1, 2, 3]
        },
        {
            id: 'util-square',
            title: 'Town Square',
            type: 'item',
            url: '/utils/square',
            icon: icons['IconBuildingFortress'],
            breadcrumbs: false,
            accessRoles: [1, 2, 3]
        },
        // {
        //     id: 'util-education',
        //     title: 'Education 🚧',
        //     type: 'item',
        //     url: '/utils/coming-soon',
        //     icon: icons['IconBrandFramer'],
        //     breadcrumbs: false
        // },
        // {
        //     id: 'util-cash-flow-management',
        //     title: 'Cash Flow Management',
        //     type: 'item',
        //     url: '/utils/cash-flow-management',
        //     icon: icons['IconCash'],
        //     breadcrumbs: false
        // },
        // {
        //     id: 'util-trade-order-development',
        //     title: 'Trade Order Development',
        //     type: 'item',
        //     url: '/utils/trade-order-development',
        //     icon: icons['IconTrendingUp'],
        //     breadcrumbs: false
        // },
        {
            id: 'util-cash-reconciliation',
            title: 'Cash Reconciliation',
            type: 'item',
            url: '/utils/cash-reconciliation',
            icon: icons['IconBrandCarbon'],
            breadcrumbs: false,
            accessRoles: [1, 2, 3]
        },
        {
            id: 'util-trade-order',
            title: 'Trade Order',
            type: 'item',
            url: '/utils/trade-order',
            icon: icons['IconGraph'],
            breadcrumbs: false,
            accessRoles: [1, 2, 3]
        },
        {
            id: 'util-trade-order-position',
            title: 'Trade Order Position',
            type: 'item',
            url: '/utils/trade-order-position',
            icon: icons['IconGraph'],
            breadcrumbs: false,
            accessRoles: [1, 2, 3]
        },
        {
            id: 'securities',
            title: 'Securities',
            type: 'item',
            url: '/securities',
            icon: icons['IconGraph'],
            breadcrumbs: false,
            accessRoles: [1]
        },
        {
            id: 'users',
            title: 'Users',
            type: 'item',
            url: '/users',
            icon: icons['IconUsers'],
            breadcrumbs: false,
            accessRoles: [1]
        },
        {
            id: 'corporate-action',
            title: 'Corporate Action',
            type: 'item',
            url: '/corporate-action',
            icon: icons['IconUsers'],
            breadcrumbs: false,
            accessRoles: [1, 2]
        },
    ]
};
